export enum HttpStatusCode {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  SUCCESS_NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  REQUEST_TIMEOUT = 408,
  INTERNAL_SERVER_ERROR = 500,
}

export enum EntityStatus {
  Inactive = 0,
  Active = 1,
}

export enum RequestMethod {
  'GET' = 'GET',
  'GET_PDF' = 'GET_PDF',
  'PUT' = 'PUT',
  'POST' = 'POST',
  'DELETE' = 'DELETE',
  'OPTIONS' = 'OPTIONS',
  'UPLOAD' = 'UPLOAD',
  'UPLOAD_MEDIA' = 'UPLOAD_MEDIA',
}

export enum Role {
  Guest = 'guest', // Gast --> everyone not signed in
  SuperAdmin = 'superAdmin', // Super administrator -> xenia ceo/employees only
  Admin = 'admin', // Administrator --> one per Company
  Berufsbildner = 'berufsbildner', // Berufsbildner/in --> n per Company,
  Ausbilder = 'ausbilder',
  Apprentice = 'apprentice', // Lernende/r --> n per Company
}

export enum UserAccountType {
  NoAccount = -1,
  Apprentice = 1,
  Praxisbildner = 2,
  Berufsbildner = 3,
  Admin = 4,
}

export enum AssessmentType {
  professionalCompetence = 'professional_competence',
  methodologicalCompetence = 'methodological_competence',
  socialCompetence = 'social_competence',
  selfCompetence = 'self_competence',
}

// Do not change the numbers,
// they are used for calculating states.
export enum Rating {
  requirementsExceeded = 3,
  fulfilled = 2,
  barelyFulfilled = 1,
  notFulfilled = 0,
}

export enum Semester {
  sem1 = 1,
  sem2 = 2,
  sem3 = 3,
  sem4 = 4,
  sem5 = 5,
  sem6 = 6,
  sem7 = 7,
  sem8 = 8,
}

export enum TrialReportRating {
  very_good = 3,
  good = 2,
  sufficient = 1,
  insufficient = 0,
}

export enum Status {
  open = 0,
  passed = 1,
  extended = 2,
  failed = 3,
  waiting = 4,
  approved = 5,
  discarded = 6,
  published = 7,
}

//
// export enum DocumentStatus {
// 	open,
// 	passed,
// 	extended,
// 	failed
// }

export enum Day {
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Sunday,
}

// export enum ProtocolCt {
//     https,
//     tcp,
//     ftp
// }

export enum LinkTypeCt {
  privateWebsite,
  companyWebsite,
  youtube,
  linkedin,
  xing,
  facebook,
  ticToc,
  instagram,
  stackOverflow,
  gitHub,
  other,
}

// 0 'Bau',
// 1 'Bildung-Soziales',
// 2 'Chemie-Physik',
// 3 'Druck',
// 4 'Elektronik',
// 5 'Fahrzeuge',
// 6 'Gastgewerbe',
// 7 'Gebäudetechnik',
// 8 'Gestaltung-Kunst',
// 9 'Gesundheit',
// 10 'Holz-Innenausbau',
// 11 'Informatik',
// 12 'Kultur',
// 13 'Metall-Maschinen',
// 14 'Nahrung',
// 15 'Natur',
// 16 'Planung-Konstruktion',
// 17 'Schönheit-Sport',
// 18 'Textilien',
// 19 'Verkauf',
// 20 'Verkehr-Logistik',
// 21 'Wirtschaft-Verwaltung'
// Berufsfeld/Fachgebiet
export enum FieldOfProfessionCt {
  'Construction',
  'EducationSocial',
  'ChemistryPhysics',
  'Printing',
  'Electronics',
  'Vehicles',
  'Hospitality',
  'BuildingServices',
  'DesignArt',
  'Health',
  'WoodInteriors',
  'InformationTechnology',
  'Culture',
  'MetalMachinery',
  'Food',
  'Nature',
  'PlanningConstruction',
  'BeautySport',
  'Textiles',
  'Sales',
  'TransportLogistics',
  'EconomyAdministration',
}

/**
 * @deprecated
 */
export enum ProfessionCt {
  'Informatik' = 1,
  'Kaufmann',
  'Detailhandelsfachmann',
  'Mediamatiker',
  'Automatiker',
  'Automatikmonteur',
  'Elektroniker',
  'Konstrukteur',
  'Logistiker',
  'Polymechaniker',
  'FachmannBetreuung',
  'ICTFachmann',
  'Augenoptiker',
}

// belongs to profession --> Fachrichtung

/**
 * @deprecated
 */
export enum SpecialityCt {
  'Systemtechnik' = 1,
  'Applikationsentwicklung',
  'Plattformentwicklung',
  'Betriebsinformatik',
  'ProfilB',
  'ProfilE',
  'ProfilM',
  'Distribution',
  'Lager',
  'Verkehr',
  'MenschenMitBeeintraechtigungen',
  'MenschenImAlter',
  'Kinder',
  'GeneralistischeAusbildung',
}

// TODO multilingual as array in the i18n json file
export enum SalutationCt {
  'Ms' = 1,
  'Mr' = 2,
  'Diverse' = 3, // Multigender
  'NoSpecification' = 4, // On purpose - undefined is basically "not yet set"
}

export enum ClothSizeCt {
  'XXS' = 1,
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'XXXL',
}

export enum TitleCt {
  'Dr.' = 'Dr.',
  'Prof.' = 'Prof.',
  'Prof. Dr.' = 'Prof.Dr.',
}

export enum JournalRythmCt {
  Weekly,
  Monthly,
}

export enum CountryCt {
  Switzerland,
  Germany,
  France,
  Italy,
  Liechtenstein,
  Austria,
}

export enum PhoneTypeCt {
  mobile = 1,
  home = 2,
  business = 3,
  other = 4,
}

export enum UrlTypeCt {
  Website,
  Linkedin,
  Xing,
  TikTok,
  Instagram,
  Facebook,
  Blog,
}

export enum PeopleNumberRangeCt {
  'x1',
  'x2-10',
  'x11-30',
  'x31-50',
  'x51-200',
  'x201-500',
  'x501-1000',
  'x1001-5000',
  'x5001-10000',
  'x>10001',
}

// export enum TimeInterval {
//     daily,
//     weekly,
//     monthly,
//     yearly
// }

export enum clothSizeLettersCt {
  xxs,
  xs,
  s,
  m,
  l,
  xl,
  xxl,
  '3xl',
  '4xl',
  '5xl',
}

/**
 *  SimpleSociety --> Einfache Gesellschaft,
 *  GeneralPartnership --> Kollektiv Gesellschaft,
 *  LimitedPartnership --> Kommandit Gesellschaft,
 *  ShareCompany --> Aktien Gesellschaft,
 *  LimitedShareCompany --> Kommandit Aktien Gesellschaft,
 *  LimitedLiabilityCompany --> Gesellschaft Mit Beschraenkter Haftung,
 *  Cooperative --> Genossenschaft,
 *  Association --> Verein
 */
export enum CompanyFormCt {
  SimpleSociety, // Einfache Gesellschaft,
  GeneralPartnership, // Kollektiv Gesellschaft,
  LimitedPartnership, // Kommandit Gesellschaft,
  ShareCompany, // Aktien Gesellschaft,
  LimitedShareCompany, // Kommandit Aktien Gesellschaft,
  LimitedLiabilityCompany, // Gesellschaft Mit Beschraenkter Haftung,
  Cooperative, // Genossenschaft,
  Association, // Verein
}

export enum CompanyLawCt {
  NaturalPerson = 1,
  JuristicPerson = 2,
  OERK = 3, // Öffentlich rechtliche Körperschaft = Staatsbetrieb oder Staatsnahe
  NGO = 4, // Non Governmental Organizations
}

export enum Language {
  German = 1,
  English = 2,
  French = 3,
  Italian = 4,
  Spanish = 5,
  Polish = 6,
  Russian = 7,
  Hindi = 8,
  Bengali = 9,
  Mandarin = 10,
  Japanese = 11,
  Arabic = 12,
  Portuguese = 13,
  Turkish = 14,
  Ukrainian = 15,
  Dutch = 16,
}

// Religious confessions to select (most popular are listed)
// do not change the number/Religion
export enum ConfessionCT {
  RomanCatholic = 1,
  Reformed = 2,
  OtherChristian = 3,
  Islam = 4,
  Judaism = 5,
  Hinduism = 6,
  Buddhism = 7,
  Sikhism = 8,
  Taoism = 9,
  Confucianism = 10,
  Other = 11,
  NoReligion = 12,
}

export enum DominantHandCt {
  left = 1,
  right = 2,
  both = 3,
  none = 4,
}

export enum ResidencePermitCt {
  B = 1, // Aufenthaltsbewilligung
  C, // Niederlassungsbewilligung
  Ci, // Aufenthaltsbewilligung mit Erwerbstätigkeit
  G, // Grenzgängerbewilligung
  L, // Kurzaufenthaltsbewilligung
  F, // Vorläufig aufgenommene Ausländerinnen, Ausländer
  N, // Asylsuchende
  S, // Schutzbedürftige
}

// https://fuehrerausweise.ch/ausweiskategorien/kategorie-a/#kat-a
export enum VehicleLicenseCategory {
  A = 1,
  A2 = 2,
  A1 = 3,
  B = 4,
  BE = 5,
  B1 = 6,
  C = 7,
  CE = 8,
  C1 = 9,
  C1E = 10,
  D = 11,
  DE = 12,
  D1 = 13,
  D1E = 14,
  M = 15,
  F = 16,
  G = 17,
  BPT = 18,
  CZV = 19,
}

// Allergien (überkategorie)
export enum Allergie {
  Pollen = 1, // Heuschnupfen
  AnimalDander, // Tierallergie
  DustMites, // Hausstaub
  InsectStings, // Insektenstiche
  Mold, // Schimmelpilz
  Food, // Nahrungsmittelallergie oder Intoleranz
  Latex, // Latex
  Medicine, // Medikamente
  Cockroaches, // Schaben oder Kakerlaken
  Sun, // Sonnenallergie
}

export enum CivilStatus {
  Single = 1, // Ledig
  Married, // Verheiratet
  Divorced, // Geschieden
  Widowed, // Verwitwet
  InRegisteredPartnership, // unverheiratet in eingetragener Partnerschaft
  PartnershipDissolvedByCourtOrder, // unverheiratet in gerichtlich aufgelöster Partnerschaft
  PartnershipDissolvedByDeath, // unverheiratet durch Tod aufgelöste Partnerschaft
  PartnershipDissolvedByDeclarationOfDisappearance, // unverheiratet aufgelöst durch Verschollenerklärung
}

export enum FoodIntolerance {
  Egg = 1, // Ei
  Peanuts, // Erdnüsse
  Fish, // Fisch
  Gluten, // Gluten/Weizen
  Shellfish, // Krustentiere
  Lupins, // Lupinen
  CowMilk, // Kuhmilch
  TreeNuts, // Schalenfrüchte
  SulphurDioxideAndSulphites, // Schwefeldioxid und Sulfite
  Celery, // Sellerie
  Mustard, // Senf
  Sesame, // Sesam
  Soy, // Soja
  Molluscs, // Weichtiere
  SesameSeed, // Sesamsamen
  Histamine, // Histamin
  Peach, // Pfirsich
  Banana, // Banane
  Avocado, // Avocado
  KiwiFruit, // Kiwi-Frucht
  PassionFruit, // Passionsfrucht
  Garlic, // Knoblauch
  Aniseed, // Anis
  Chamomile, // Kamille
  Linseed, // Leinsamen
  Other, // Nicht aufgeführt - mit uns kontakt aufnehmen oder Kommentarfunktion
}

// Used to define the relation type of one person to the other
export enum RelationType {
	Mother = 1,
	Father,
	Brother,
	Sister,
	GrandMother,
	GrandFather,
	Uncle,
	Aunt,
	Son,
	Daughter,
	Other,
}

export enum ApprenticeshipTypeCt {
	efz = 1,
	eba = 2,
	way_up = 3,
	ims = 4,
}

export enum ApprenticeshipModuleType {
	ProfessionalModule = 1,
	SchoolSubject = 2,
	Matura = 4,
	UEK = 3,
}